import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { KeepAliveService } from './utility/keep-alive.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'tongue diagnosis';
  constructor(
    private appService: AppService,
    private keepAliveService: KeepAliveService
  ) {}

  ngOnInit() {
    // KeepAliveService will be started after login or session restoration
  }

  get block(): boolean {
    return this.appService.isBlock;
  }
}
